import { TFooterLink, TFooterLinkFields, TFooterSectionFields } from '../../../../../types/footerLink.types';
import { TActionSectionProps } from '../types/actionSection.types';
import { SectionType } from '../enums/actionSection.enums';

export class ActionSectionModel {
  private readonly fields?: TFooterSectionFields;

  constructor(props: TActionSectionProps) {
    this.fields = props.field || null;
  }

  // eslint-disable-next-line
  get dealerLoginLink(): TFooterLinkFields | undefined {
    const find = (list: TFooterLink[]): TFooterLink | undefined => {
      return list?.find((item) => item?.fields?.type?.fields?.Key?.value === SectionType.LoginLink);
    };

    const result = this.fields?.footerLinks && find(this.fields?.footerLinks);
    if (result?.fields) {
      return result?.fields;
    }
    return undefined;
  }

  // eslint-disable-next-line
  get dealerRequestLink(): TFooterLinkFields | undefined {
    const find = (list: TFooterLink[]): TFooterLink | undefined => {
      return list?.find((item) => item?.fields?.type?.fields?.Key?.value === SectionType.RequestLink);
    };
    const result = this.fields?.footerLinks && find(this.fields?.footerLinks);
    if (result?.fields) {
      return result?.fields;
    }
    return undefined;
  }

  get marketSelector(): TFooterLinkFields | undefined {
    const marketSelectorContainer = this.fields?.footerLinks?.find(
      (link: TFooterLink) => link?.fields?.type?.fields?.Key?.value === SectionType.MarketSelector
    );
    return marketSelectorContainer?.fields?.list?.[1]?.fields;
  }

  get languageSelector(): TFooterLinkFields | undefined {
    const marketSelectorContainer = this.fields?.footerLinks?.find(
      (link: TFooterLink) => link?.fields?.type?.fields?.Key?.value === SectionType.MarketSelector
    );
    return marketSelectorContainer?.fields?.list?.[0]?.fields;
  }
}
